import React from 'react';
import RateManagementWidget from '../RateManagment/RateManagementWidget';
import COLUMNS from './table_columns';
import PropTypes from 'prop-types';

//import fileDownload from 'js-file-download';
import FileSaver from 'file-saver';
import { toast } from 'react-toastify';

export default class BaseRateManagementWidget extends React.Component {

  constructor(props) {
    super(props);
    this.onBulkEditAcceptChanges = this.onBulkEditAcceptChanges.bind(this);
    this.onSingleEditAcceptChanges = this.onSingleEditAcceptChanges.bind(this);
    this.onUpdateBaseWithCurrent = this.onUpdateBaseWithCurrent.bind(this);
    this.onRevertCurrentRates = this.onRevertCurrentRates.bind(this);
    this.onDownload = this.onDownload.bind(this);
    this.onImport = this.onImport.bind(this);
    this.onAddRateData = this.onAddRateData.bind(this);
    this.onRemoveSelected = this.onRemoveSelected.bind(this);


    this.state = {
      downloadCSVLink: null
    };
  }

  onRevertCurrentRates() {
    let { updateRateSheet, getRateSheet, uiState } = this.props;
    let { terminalObject, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;

    updateRateSheet({
      query: {
        operator: "BASE_TO_CURRENT"
      },
      terminalId,
      orgId
    }, () => {
      getRateSheet({
        terminalId: terminalId
      });
    });
  }

  onUpdateBaseWithCurrent() {
    let { updateRateSheet, getRateSheet, uiState } = this.props;
    let { terminalObject, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;

    updateRateSheet({
      query: {
        operator: "CURRENT_TO_BASE"
      },
      terminalId,
      orgId
    }, () => {
      getRateSheet({
        terminalId: terminalId
      });
    });
  }

  onBulkEditAcceptChanges() {

    const { setUiState, uiState, getRateSheet, updateRateSheet } = this.props;
    let { selectedObjects, terminalObject, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;

    updateRateSheet({
      query: {
        operator: uiState.currentUpdate.operator,
        number: uiState.currentUpdate.number,
        values: selectedObjects
      },
      terminalId,
      orgId
    }, () => {

      setUiState({
        filters: {},
        selectedIndexes: [],
        selectedObjects: []
      });

      getRateSheet({
        terminalId,
        orgId
      });
    });
  }

  onSingleEditAcceptChanges() {

    const { setUiState, uiState, getRateSheet, updateRateSheet } = this.props;
    let { terminalObject, selectedObjects, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;


    selectedObjects = selectedObjects.map(obj => {

      let newRate = parseFloat(obj.newRate);
      let rate = parseFloat(obj.rate);      
      if(!isNaN(newRate)){
        obj.newRate = newRate;
      }else{
        obj.newRate = rate;
      }
      return obj;
    });

    updateRateSheet({
      query: {
        operator: "MULTI_SET",
        values: selectedObjects
      },
      terminalId,
      orgId
    }, () => {

      setUiState({
        filters: {},
        selectedIndexes: [],
        selectedObjects: []
      });

      getRateSheet({
        terminalId,
        orgId
      });
    });

  }

  onRemoveSelected(selected) {
    let { getRateSheet, uiState, setUiState, dispatchDeleteRateData } = this.props;
    let { terminalObject, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : "";
    let orgId = clientObject ? clientObject.value : "";

    dispatchDeleteRateData({
      deleteRatesBody: {
        rates: selected
      }
    }, (err, result) => {
      if (err) {
        toast.error(err.message);
      } else {
        toast.success("Delete Complete");
        getRateSheet({
          terminalId,
          orgId
        });

        setUiState({
          filters: {},
          selectedIndexes: [],
          selectedObjects: []
        });
      }
    });

  }

  onAddRateData(data) {
    let { getRateSheet, uiState, dispatchAddRateData } = this.props;
    let { terminalObject, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : "";
    let orgId = clientObject ? clientObject.value : "";

    let fixed = data.map(data => {
      return {
        destination: data.destination,
        state: data.state,
        zip: parseInt(data.zip),
        rate: parseFloat(data.rate),
        baseRate: parseFloat(data.baseRate)
      };
    });
    dispatchAddRateData({
      addRatesBody: {
        orgId,
        terminalId,
        rates: fixed
      }
    }, (err, result) => {
      if (err) {
        toast.error(err.message);
      } else {
        toast.success("Update Complete");
        getRateSheet({
          terminalId,
          orgId
        });
      }
    });
  }

  onDownload() {
    let { getRateSheet, uiState, dispatchGetRateSheetCSV } = this.props;
    let { terminalObject, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;


    dispatchGetRateSheetCSV({
      terminalId,
      orgId,
      fileFormat: "csv"
    }, (err, data) => {
      if (!err) {
        var file = new File([data], "rates.csv", { type: "text/plain;charset=utf-8" });
        FileSaver.saveAs(file);
      }
    });
  }

  onImport(data) {

    if (data && data.file && data.file.name) {
      let { getRateSheet, uiState, dispatchImportCSV } = this.props;
      let { terminalObject, clientObject } = uiState;
      let terminalId = terminalObject ? terminalObject.value : null;
      let orgId = clientObject ? clientObject.value : null;


      let extension = data.file.name.split('.').pop().toLowerCase();

      dispatchImportCSV({
        terminalId,
        orgId,
        fileFormat: extension,
        file: data.file
      }, (err, result) => {
        if (err) {
          toast.error(err.message);
          /*
          err.message.forEach((e) => {
            toast.error(e.error);
          });
          */

        } else {
          toast.success("Successfully Uploaded Rates");
          /*
          result.warning.forEach((e) => {
            toast.warn(e.warning);
          });
          */
          getRateSheet({
            terminalId,
            orgId
          });
        }
      });
    }else{
      toast.error("Invalid File");
    }
    //console.log(data);
  }

  render() {
    let { uiState, setUiState } = this.props;
    let { terminalObject, clientObject } = uiState;
    let terminalId = terminalObject ? terminalObject.value : null;
    let orgId = clientObject ? clientObject.value : null;

    //let downloadCSVLink = `/api/rates?terminalId=${terminalId}&orgId=${orgId}&fileFormat=csv`;

    return (
      <RateManagementWidget
        addRemove={true}
        setUiState={setUiState}
        downloadType="CSV"
        importAccept={[".csv", ".xlsx"]}
        terminalName={uiState.terminalObject ? uiState.terminalObject.label : ""}
        selectedObjects={uiState.selectedObjects}
        editColumns={COLUMNS.baseRateEditColumns}
        addColumns={COLUMNS.baseRateAddColumns}
        previewColumns={COLUMNS.baseRatePreviewColumns}
        onRemoveSelected={this.onRemoveSelected}
        onAddRateData={this.onAddRateData}
        onBulkEditAcceptChanges={this.onBulkEditAcceptChanges}
        onSingleEditAcceptChanges={this.onSingleEditAcceptChanges}
        onUpdateBaseWithCurrent={this.onUpdateBaseWithCurrent}
        onRevertCurrentRates={this.onRevertCurrentRates}
        onDownload={this.onDownload}
        onImport={this.onImport}
      />
    );
  }
}

BaseRateManagementWidget.propTypes = {
  uiState: PropTypes.object,
  setUiState: PropTypes.func,
  updateRateSheet: PropTypes.func,
  getRateSheet: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/components/BaseRates/BaseRateManagementWidget.js